import api from '../index';

export const generateCoreDefinitions = async (data) => {
  const response = await api.post('/ai/generate-core-definitions', data);
  return response.data;
};

export const getQuiz = async (quiz_id) => {
  const response = await api.get(`/quizzes/${quiz_id}`);
  return response.data;
};

// export const generateQuestions = async (data) => {
//   const response = await api.post('/ai/generate-questions', data);
//   return response.data;
// };

export const askAssistant = async (data) => {
  const response = await api.post('/assistant', {
    "message": "{ 'task': 'generate_questions', 'core_definition': 'Lungs are organs responsible for gas exchange during breathing.', 'topic': 'Respiratory System', 'class': 'Basic 5', 'subject': 'Science' }"
  });
  return response.data;
};

export const saveQuiz = async (data) => {
  console.log(data)
  const response = await api.post('/quizzes', data);
  return response.data;
};

export const saveQuizAttempt = async (data) => {
  console.log(data)
  const response = await api.post('/quiz-attempts', data);
  return response.data;
};

export const getWeeklyQuizSummaries = async () => {
  const response = await api.get('students/week-quiz-summary');
  return response.data;
};

export const getCoursePlanDetails = async (courseId) => {
  const response = await api.get(`courses/${courseId}/plan`);
  return response.data;
};




